import { safeResearchUrl } from './classicResearch.js'
import { parseScrapedAt } from './servedTime.js'

/** Optional, explicitly scoped operator checks. They cannot certify condition,
 * NL resale value or a new release. Expired/mismatched checks confer no trust. */
export function classicSourceReview(car, feed, now = new Date()) {
  if (!supported(feed) || !Array.isArray(feed.rows) || !car.listing_id || !car.decision_snapshot_id || !car.model_git_sha) return null
  return latestReview(feed.rows.filter(r => String(r.listing_id) === String(car.listing_id) && r.country_code === car.country_code &&
    r.decision_snapshot_id === car.decision_snapshot_id && r.model_git_sha === car.model_git_sha &&
    r.asking_price === Number(car.price_amount_eur)), now)
}

const supported = feed => ['classic-source-review.v1', 'classic-source-review.v2'].includes(feed?.schema)

function latestReview(rows, now) {
  return rows.flatMap(row => {
    if (!/T.*(?:Z|[+-]\d\d:\d\d)$/.test(String(row.checked_at))) return []
    const checked = parseScrapedAt(row.checked_at), age = now.getTime() - checked?.getTime()
    const url = safeResearchUrl(row.source_url)
    if (!Number.isFinite(age) || age < 0 || age >= 86400000 || !url ||
      !['advert_matched', 'unavailable', 'unresolved', 'blocked', 'price_changed', 'condition'].includes(row.status)) return []
    return [{ ...row, source_url: url }]
  }).sort((a, b) => new Date(b.checked_at) - new Date(a.checked_at) ||
    Number(a.status === 'advert_matched') - Number(b.status === 'advert_matched'))[0] || null
}

/** The NL reference feed has no model release SHA. Bind checks to its complete
 * advertised identity, observation, price and URLs instead of inventing one. */
export function classicReferenceFingerprint(row) {
  const e = row.evidence || {}
  return JSON.stringify([row.id, e.listing_id, row.observed_at, row.make, row.model, row.year, row.price,
    e.mileage_km, e.horsepower_hp, e.fuel_type, e.fuel_normalized, e.car_type, e.body_normalized,
    e.transmission, e.transmission_normalized, e.seller_type, e.external_link, e.detail_page_url])
}

export function classicReferenceSourceReview(reference, feed, now = new Date()) {
  if (feed?.schema !== 'classic-source-review.v2' || !Array.isArray(feed.reference_rows) ||
    !reference.id || !reference.evidence?.listing_id || !reference.observed_at) return null
  const fingerprint = classicReferenceFingerprint(reference)
  return latestReview(feed.reference_rows.filter(row => row.country_code === 'NL' &&
    String(row.listing_id) === String(reference.evidence.listing_id) && row.reference_id === reference.id &&
    row.reference_fingerprint === fingerprint && row.asking_price === Number(reference.price)), now)
}
